export default __webpack_public_path__ + "static/media/additional-work-timekeeping.7fd6d745.svg";